var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_28990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_28990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1837 31.875L9.49199 27.3417L4.39199 26.2083L4.88783 20.9667L1.41699 17L4.88783 13.0333L4.46283 8.42917L1.98366 5.95L3.96699 3.96667L30.0337 30.0333L28.0503 32.0167L24.0837 28.05L21.817 31.875L17.0003 29.8208L12.1837 31.875ZM29.1128 20.9667L29.5378 25.5708L20.7545 16.7875L23.517 14.025L21.5337 11.9708L18.7357 14.7688L9.91699 5.91458L12.1837 2.125L17.0003 4.17917L21.817 2.125L24.5087 6.65833L29.6087 7.79167L29.1128 13.0333L32.5837 17L29.1128 20.9667ZM15.5128 22.0292L16.7878 20.7542L11.7587 15.725L10.4837 17L15.5128 22.0292Z",
    fill: "#DC2626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedOff);
export default __webpack_public_path__ + "static/media/verified_off.a988ab25a656ab1ac294310e4bbcef03.svg";
export { ForwardRef as ReactComponent };